export const selectedLocationKey = "selected-location";